import { ButtonIcon } from '@tallink/components-lib'
import * as PropTypes from 'prop-types'
import React from 'react'
import { useHistory } from 'react-router-dom'

import s from './ButtonBack.module.scss'

export default function ButtonBack({ onClick }) {
  const history = useHistory()

  return <ButtonIcon className={s['button-back']} iconSize="l" iconType="chevron-left" onClick={handleClick} />

  function handleClick() {
    if (onClick) onClick()
    else history.goBack()
  }
}

ButtonBack.propTypes = {
  onClick: PropTypes.func
}
